import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => {
  return {
    noWrap: {
      whiteSpace: 'nowrap'
    },

    icon: {
      flexShrink: 0
    }
  }
})
